import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sheed-product',
  templateUrl: './sheed-product.component.html',
  styleUrls: ['./sheed-product.component.scss']
})
export class SheedProductComponent implements OnInit {

  @Input() productId!: number;
  @Input() productName!: string;
  constructor() { }

  ngOnInit() {
  }

  getProductImg() {
    if(!this.productId || this.productId==0){
      if(this.productName=='امنیت اینترنتی شید')
        this.productId=9;
      if(this.productName=='آنتی‌ویروس شید')
        this.productId=1;
    }
    switch (this.productId) {
      case 1:
        return "./../../../../../../assets/media/icons/dashboard/antivirus-icon-24x24.png";
      case 11:
        return "./../../../../../../assets/media/icons/dashboard/shredder-icon-24x24.png";
      case 9:
        return "./../../../../../../assets/media/icons/dashboard/is-icon-24x24.png";
      default:
        return "./../../../../../../assets/media/icons/dashboard/antivirus-icon-24x24.png";
    }
  }

}
